import { useEffect, useState } from "react";
import './index.scss';

export default function PasswordRequirements({ rules, value, className, ...props }) {
    const [validationStatus, setValidationStatus] = useState(rules);
    const allRulesPass = Object.values(validationStatus).filter((rule) => !rule.pass).length === 0;

    useEffect(() => {
        const validatePassword = () => {
            for (const rule in rules) {
                const patternToTest = rules[rule].pattern;
                if (patternToTest.test(value)) setValidationStatus((prevState) => ({ ...prevState, [rule]: { ...rules[rule], pass: true } }))
                else setValidationStatus((prevState) => ({ ...prevState, [rule]: { ...rules[rule], pass: false } }))
            }
        }

        validatePassword();
    }, [rules, value])

    if (!value || !rules || allRulesPass) return null
    return (
        <div id='container' className={`${className ?? ''}`} {...props}>
            <div id='title'>Password must contain the following:</div>
            <div id='rules'>
            {Object.values(validationStatus).map((rule) => {
                return <div>{rule.pass ? <span className='rule pass'>✓</span> : <span className='rule fail'>✕</span>} <span className='rule message'>{rule.message}</span></div>
            })}
            </div>
        </div>
    )
}
